import { formatMoney, type Currency } from '@atek/estimate-pricing';
import type { Lang } from '../types';

/** The UI language as a money/label language ('fr-CA' → 'fr'); anything else is English. */
export const uiLang = (language: string | undefined): Lang => (language?.startsWith('fr') ? 'fr' : 'en');

export const estimateLabel = (estimate: { number: string; revision: number }) => `${estimate.number} r${estimate.revision}`;

/** "$4,754 – $7,225" across the budgets' Year 1; one amount when they are all equal. */
export function year1Range(budgets: { year1: number }[], currency: Currency, lang: Lang): string {
  if (!budgets.length) return '—';
  const values = budgets.map((b) => b.year1);
  const min = Math.min(...values);
  const max = Math.max(...values);
  return min === max ? formatMoney(min, currency, lang) : `${formatMoney(min, currency, lang)} – ${formatMoney(max, currency, lang)}`;
}

export const slidesUrl = (fileId: string) => `https://docs.google.com/presentation/d/${encodeURIComponent(fileId)}/edit`;
export const deckPdfUrl = (fileId: string) => `https://docs.google.com/presentation/d/${encodeURIComponent(fileId)}/export/pdf`;
